  function initQuickLinks(root) {
    const wrap = root.querySelector('[data-quick-links]');
    if (!wrap) return;

    const indicator = wrap.querySelector('.immo-quick-links__indicator');
    const items = Array.from(wrap.querySelectorAll('.immo-quick-links__item'));
    if (!indicator || !items.length) return;

    const getActive = () => wrap.querySelector('.immo-quick-links__item.is-active') || items[0];

    function moveTo(el) {
      if (!el) return;

      const wrapRect = wrap.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();

      const left = elRect.left - wrapRect.left + wrap.scrollLeft;
      const width = elRect.width;

      indicator.style.transform = `translateX(${left}px)`;
      indicator.style.width = `${width}px`;

      items.forEach(i => i.classList.remove('is-over'));
      el.classList.add('is-over');
    }

    function moveToActive() {
      moveTo(getActive());
      items.forEach(i => i.classList.remove('is-over'));
      getActive().classList.add('is-over');
    }

    // init pozicija
    requestAnimationFrame(moveToActive);

    // hover/focus
    items.forEach((item) => {
      item.addEventListener('mouseenter', () => moveTo(item));
      item.addEventListener('focus', () => moveTo(item));
    });

    // leave -> nazad na active
    wrap.addEventListener('mouseleave', moveToActive);
    wrap.addEventListener('focusout', (e) => {
      // kad fokus ode van wrappera
      if (!wrap.contains(e.relatedTarget)) moveToActive();
    });

    // responsive: recalc na resize
    window.addEventListener('resize', () => moveToActive());

    // ako je horizontal scroll na mobile
    wrap.addEventListener('scroll', () => moveToActive(), {
      passive: true
    });
  }

  function initCf7FileInputs() {
    const fileInputs = document.querySelectorAll('.choose-file input[type="file"]');
    if (!fileInputs.length) return;

    fileInputs.forEach((input) => {
      if (input.nextElementSibling && input.nextElementSibling.classList.contains('cf7-file-ui')) {
        return;
      }

      const ui = document.createElement('div');
      ui.className = 'cf7-file-ui';
      ui.innerHTML = '<span class="cf7-file-name">kein Bild ausgewählt</span><span class="cf7-file-btn">Bild auswählen</span>';
      input.insertAdjacentElement('afterend', ui);

      const fileName = ui.querySelector('.cf7-file-name');
      const defaultText = 'kein Bild ausgewählt';

      const updateFileName = () => {
        if (input.files && input.files.length > 0) {
          fileName.textContent = input.files.length > 1 ? `${input.files.length} Bilder ausgewählt` : input.files[0].name;
          return;
        }

        fileName.textContent = defaultText;
      };

      input.addEventListener('change', updateFileName);
      updateFileName();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.block_quick_links').forEach(initQuickLinks);
    initCf7FileInputs();
  });

  (function ($) {
    $(function () {



      $('.nav-button').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.navigation-floating').toggleClass('opened');
        $('.overlay-black').addClass('active');

      });

      $('.nav-button.active').on('click', function () {
        $(this).removeClass('active');
        $('.navigation-floating.opened').removeClass('opened');
      });

      /*
       * Navbar fixed 
       */
      $(window).on('scroll', function () {
        if ($(this).scrollTop() > 1) {
          $('.site-header').addClass('navbar-fixed-top fadeInDown animated ');
        } else {
          $('.site-header').removeClass('navbar-fixed-top fadeInDown animated');
        }
      });

      /*
       * Toggle burger menu on mobile
       */
      $('.menu-btn-burger').on('click', function () {
        $('#nav-icon').toggleClass('open-custom-menu');
        $(".mobile-menu").toggleClass('sliding-open');
      });

      /* 
       * Owl carousel
       */
      $('.owl-room-card').owlCarousel({
        margin: 40,
        items: 3,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4500,
        nav: true,
        dots: false,
        animateOut: 'fadeOut',
        navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        // navContainer: '#customNav',
        responsive: {
          0: {
            items: 1
          },
          700: {
            items: 2,
            margin: 0,
          },
          1200: {
            items: 3,
          }
        }
      });
 
      /*
       * Video modal 
       */
      $("body").on("click", "#play-video-modal", function (e) {
        e.preventDefault();
        $("#video-modal").modal("show");
        $("#video-modal iframe")[0].src += "?autoplay=1";
      });

      $("#video-modal").on('hidden.bs.modal', function (e) {
        var videoUrl = $("#video-modal iframe")[0].src;
        videoUrl = videoUrl.replace("?autoplay=1", "");
        $("#video-modal iframe")[0].src = videoUrl;
      });

      /*
       * Footer CTA video modal
       */
      const $footerVideoModal = $("#footer-video-modal");
      const $footerIframe = $("#footer-cta-video");
      const footerBaseSrc = $footerIframe.data("src");

      $("body").on("click", "[data-footer-video-trigger]", function (e) {
        e.preventDefault();
        $footerVideoModal.modal("show");
      });

      $("body").on("keydown", "[data-footer-video-trigger]", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          $footerVideoModal.modal("show");
        }
      });

      $footerVideoModal.on("shown.bs.modal", function () {
        if (footerBaseSrc) {
          $footerIframe.attr("src", footerBaseSrc);
        }
      });

      $footerVideoModal.on("hide.bs.modal", function () {
        $footerIframe.attr("src", "about:blank");
      });

      /*
       * Youtube lazy loading
       */
      $('#play-video-btn').on('click', function (e) {
        e.preventDefault();
        $('#youtubeModal').modal('show');
      });

      $("#youtubeModal").on('hidden.bs.modal', function (e) {
        $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
      });



      /*
       * Scroll up button
       */
      $(window).scroll(function () {
        if ($(this).scrollTop() > 150) {
          $('.scroll-to-top').addClass('show');
        } else {
          $('.scroll-to-top').removeClass('show');
          $('.scroll-to-top').addClass('animated bounceOutDown');
          $('.scroll-to-top').removeClass('animated bounceOutUp');
          $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
        }
      }); 

      $('.scroll-to-top').on("click", function () {
        $('.scroll-to-top').addClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
        $("html, body").animate({
          scrollTop: 0
        }, 1000);
        return false;
      });

      /*
       * Lightbox gallery
       */
      $('.gallery-images').lightGallery({
        selector: '.gallery-item',
        share: true,
        download: true,
        rotate: false,
        showThumbByDefault: true,
        loop: false,
        slideEndAnimatoin: false,
        thumbnail: true,
        allowMediaOverlap: true,
        toggleThumb: true,
        youtubePlayerParams: {
          loadYoutubeThumbnail: true,
          youtubeThumbSize: 'default',
          modestbranding: 1,
          showinfo: 0,
          rel: 0
        }
      });



      /*
       * Mmenu light 
       */
      var menu = new MmenuLight(
        document.querySelector('#my-menu'),
        'all'
      );
      if (menu) {
        var navigator = menu.navigation({
          // selectedClass: 'Selected',
          // slidingSubmenus: true,
          theme: 'light',
          title: 'Menü'
        });

        var drawer = menu.offcanvas({
          position: 'right'
        });

        //  Open the menu.
        document.querySelector('#nav-icon')
          .addEventListener('click', evnt => {
            evnt.preventDefault();
            drawer.open();
          });

        $(".mob-menu-close").click(function () {
          drawer.close();
        });
      }

    });
  })(jQuery);
